import { render } from "./RequestNormal.vue?vue&type=template&id=67be43c2&scoped=true&ts=true"
import script from "./RequestNormal.vue?vue&type=script&lang=ts"
export * from "./RequestNormal.vue?vue&type=script&lang=ts"

import "./RequestNormal.vue?vue&type=style&index=0&id=67be43c2&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67be43c2"]])

export default __exports__